import {CategoryType} from './category-type';

export const CATEGORYTYPES: CategoryType[] = [
  {
    id: 1,
    name: 'Flight',
    short_name: 'Flt',
    upa_uta: 'UPA',
    position: {active: true},
  },
  {
    id: 2,
    name: 'Departure',
    short_name: 'Dep',
    upa_uta: 'UPA',
    position: {active: false},
  },
  {
    id: 3,
    name: 'Connection',
    short_name: 'Cxn',
    upa_uta: 'UPA',
    position: {active: false},
  },
  {
    id: 4,
    name: 'Arrival',
    short_name: 'Arr',
    upa_uta: 'UPA',
    position: {active: false},
  },
  {
    id: 5,
    name: 'Messaging',
    short_name: 'Msg',
    upa_uta: 'UPA',
    position: {active: false},
  },
  {
    id: 6,
    name: 'Airline',
    short_name: 'Air',
    upa_uta: 'UPA',
    position: {active: false},
  },
  {
    id: 7,
    name: 'Change',
    short_name: 'Chng',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 8,
    name: 'Bag',
    short_name: 'Bag',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 9,
    name: 'Seat',
    short_name: 'Seat',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 10,
    name: 'Airport',
    short_name: 'Apt',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 11,
    name: 'Rewards',
    short_name: 'Rwd',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 12,
    name: 'Transferable Funds',
    short_name: 'Tfs',
    upa_uta: 'UTA',
    position: {active: false},
  },
  {
    id: 0,
    name: 'Custom',
    short_name: 'Cus',
    upa_uta: 'UPA',
    position: {active: false},
  },
];
